import { render } from "./ShipmentDetail.vue?vue&type=template&id=18dfc687&scoped=true"
import script from "./ShipmentDetail.vue?vue&type=script&lang=js"
export * from "./ShipmentDetail.vue?vue&type=script&lang=js"

import "./ShipmentDetail.vue?vue&type=style&index=0&id=18dfc687&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18dfc687"]])

export default __exports__